import type { ComponentProps } from 'react';
import { TextField } from './text-field';

type DateFieldProps = Omit<ComponentProps<typeof TextField>, 'type' | 'suggestions' | 'inputMode'>;

export function DateField(props: DateFieldProps) {
  return <TextField {...props} type="date" />;
}
